//let blocks = [{"id":0,"parent":-1,"data":[{"name":"blockelemtype","value":"1"},{"name":"blockid","value":"0"}],"attr":[{"class":"blockelem noselect block"},{"style":"left: 266px; top: 38px;"}]},{"id":1,"parent":0,"data":[{"name":"blockelemtype","value":"7"},{"name":"blockid","value":"1"}],"attr":[{"class":"blockelem noselect block"},{"style":"left: 97px; top: 228px;"},{"data-blocktype":"email"},{"data-emailtemplate":"newpatienttemp"},{"data-onlyifpreviousunopened":"false"}]},{"id":2,"parent":0,"data":[{"name":"blockelemtype","value":"6"},{"name":"blockid","value":"2"}],"attr":[{"class":"blockelem noselect block"},{"style":"left: 435px; top: 228px;"},{"data-blocktype":"sms"},{"data-smstemplate":"newpatienttemp"},{"data-smssendon":"immediately"}]},{"id":3,"parent":1,"data":[{"name":"blockelemtype","value":"9"},{"name":"blockid","value":"3"}],"attr":[{"class":"blockelem noselect block"},{"style":"left: 97px; top: 418px;"},{"data-blocktype":"wait"}]},{"id":4,"parent":3,"data":[{"name":"blockelemtype","value":"7"},{"name":"blockid","value":"4"}],"attr":[{"class":"blockelem noselect block"},{"style":"left: 97px; top: 608px;"},{"data-blocktype":"email"},{"data-emailtemplate":"newpatienttemp"},{"data-onlyifpreviousunopened":"false"}]}];

/* eslint-disable */

var AwsStlConverter = (function() {

  var blocks;

  let stlTemplate = {
    StartAt: "Try",
    States: {
      Try: {
        Type: "Parallel",
        Next: "UnwrapOutput",
        Branches: [
          {
            StartAt: "1",
            States: {}
          }
        ],
        Catch: [
          {
            ErrorEquals: ["States.ALL"],
            Next: "NotifyError",
            ResultPath: "$.error"
          }
        ]
      },
      UnwrapOutput: {
        Type: "Pass",
        InputPath: "$[0]",
        Next: "NotifySuccess"
      },
      NotifySuccess: {
        Type: "Pass",
        End: true
      },
      NotifyError: {
        Type: "Task",
        Resource: "arn:aws:states:::sns:publish",
        Parameters: {
          TopicArn: "arn:aws:sns:us-east-1:581565885944:alert",
          "Message.$": "$.error",
        },
        End: true
      }
    }
  };

  function makeParallelState(blocks, allblocks) {
    let tpl = {
      Type: "Parallel",
      End: true,
      Branches: []
    };

    let tpl2;
    let state;
    let name;
    let currentParent;
    let children;
    let currentBlockIndex = null;
    let continueLoop = true;
    let nextBlockIndex = null;
    let uniqueID = Date.now();
    let stateName;
    let currentStateName, parentStateName;

    for (let block of blocks) {
      tpl2 = {
        States: {}
      };

      state = makeState(block);
      currentBlockIndex = getBlockIndex(blocks, block);
      //console.log(`currentBlockIndex: ${currentBlockIndex}`);
      stateName = "state-" + block.id + "-" + uniqueID;
      
      /*
        tpl2.States[block.id] = state;
        tpl2.StartAt = '' + block.id;
      */

      tpl2.States[stateName] = state;
      tpl2.StartAt = stateName;

      currentParent = block;

      do {
        //console.log(`currentBlockIndex: ${currentBlockIndex}`);
        //children = getChildren(blocks, currentBlockIndex);
        children = getChildren(allblocks, currentParent.id);
        //console.log(`current parent`);
        //console.log(currentParent);
        if (children.length === 0) {
          state = makeState(currentParent);
          /*
          tpl2.States[currentParent.id] = state;
          tpl2.States[currentParent.id].End = true;
          */
          stateName = "state-" + currentParent.id + "-" + uniqueID;
          tpl2.States[stateName] = state;
          tpl2.States[stateName].End = true;
          continueLoop = false;
        } else if (children.length > 1) {
          //console.log(`has more than 1 children so need to make parallel`);
          name = makeParallelStateName(children);
          state = makeParallelState(children, allblocks);
          tpl2.States[name] = state;                    
          if(currentStateName)
            tpl2.States[currentStateName].Next = name;
          else
            tpl2.States[stateName].Next = name;
          continueLoop = false;
        } else if (children.length === 1) {
          //console.log(`has one children`);
          state = makeState(children[0]);
          //console.log(`got state back`);
          //console.log(state);
          nextBlockIndex = getBlockIndex(blocks, children[0]);

          //let temp = "state-" + children[0].id + "-" + uniqueID;
          //let parent_temp = "state-" + currentParent.id + "-" + uniqueID;

          currentStateName = "state-" + children[0].id + "-" + uniqueID;
          parentStateName = "state-" + currentParent.id + "-" + uniqueID;
          tpl2.States[currentStateName] = state;
          tpl2.States[parentStateName].Next = currentStateName;
          
        }

        if(children.length === 1) {
          currentParent = children[0];
          if (currentParent) {
            currentBlockIndex = getBlockIndex(allblocks, currentParent);
            if(getChildren(allblocks, currentParent.id).length > 0) {
              continueLoop = true;
            }
            else {
              if(currentStateName)
              tpl2.States[currentStateName].End = true;
              continueLoop = false;
            }
          }
        }
      } while (continueLoop);

      tpl.Branches.push(tpl2);
    }

    //console.log(`In makeparallel, Returning template`);
    //console.log(tpl);

    return tpl;
  }


  function makeParallelStateName(blocks) {
    let name = "";
    blocks.forEach(function (b) {
      //name = name + "-" + getBlockIndex(blocks, b);
      name = name + "-" + b.id;
    });
    return name.substr(1, name.length); // remove the first dash
  }

  function getBlockType(block) {
    //return block.attr.filter((a) => a["data-blocktype"])[0]["data-blocktype"];

    /*
    if(block.data[0].value !== 'triggers') {    
      let bType = block.attr.filter(function(a) {
        if(a["data-blocktype"]) {
          return a["data-blocktype"][0]["data-blocktype"];
        }
      });
      if(bType)
        return bType;
      else {
        const error = new Error(`blocktype missing for block: ${JSON.stringify(block)}`);
        error.code = 'BLOCK_TYPE_MISSING';
        throw error;
      }
    }
    */
    if(block.data[0].value !== 'triggers') {
      let temp = block.attr.find(a=> a['data-blocktype']);
      if(temp)
        return temp['data-blocktype'];
      /*
      else {
        const error = new Error(`blocktype missing for block: ${JSON.stringify(block)}`);
        error.code = 'BLOCK_TYPE_MISSING';
        throw error;
      }  
      */
    }
  }

  function getAttribute(block, attr) {
    let fullAttr = `data-${attr}`;    
    let a = block.attr.find(a =>a[fullAttr]);
    if(a)
      return a[fullAttr];
    else
      return "";
  }

  function makeState(block) {
    //console.log(`Trying to make state for block`);
    //console.dir(block);

    let template;
    let blockType;
    let siteStage;

    let host = window.location.href;

    if (host.includes('prod.teamio.app')) {
      siteStage = 'prod';
    } else
      siteStage = 'dev';

    try {
      blockType = getBlockType(block);    
      //console.log(`blockType: ${blockType}`);
      //console.log(`Email from: ${getAttribute(block, 'emailfrom')}`);

      switch (blockType) {
        case "email":
          template = {
            Type: "Task",
            Resource: "arn:aws:states:::lambda:invoke",
            Parameters: {
              FunctionName:
                `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
              Payload: {
                type: "EMAIL",
                siteID: getAttribute(block, 'siteid'),
                timezone: getAttribute(block, 'timezone'),
                workflowID: getAttribute(block, 'workflowid'),
                workflowTrigger: getAttribute(block, 'workflowtrigger'),
                fromName: getAttribute(block, 'emailfromname'),
                fromEmail: getAttribute(block, 'emailfromemail'),
                onlyifpreviousunopened: getAttribute(block, 'onlyifpreviousunopened'),
                properties: getAttribute(block, 'send-email-properties'),
                "originalEvent.$": "$",
                "executionID.$": "$$.Execution.Id"
              }
            },
            Retry: [{
              "ErrorEquals": ["States.TaskFailed"],
              "IntervalSeconds": 1,
              "MaxAttempts": 2,
              "BackoffRate": 2.0
            }],
            TimeoutSeconds: 300,
            ResultPath: "$.TaskResult",
            OutputPath: "$"
          };
          break;
        case "sms":
          template = {
            Type: "Task",
            Resource: "arn:aws:states:::lambda:invoke",
            Parameters: {
              FunctionName:
                `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
              Payload: {
                type: "SMS",
                siteID: getAttribute(block, 'siteid'),
                workflowID: getAttribute(block, 'workflowid'),
                workflowTrigger: getAttribute(block, 'workflowtrigger'),
                smsFrom: getAttribute(block, 'smsfrom'),
                properties: getAttribute(block, 'send-sms-properties'),
                "originalEvent.$": "$",
                "executionID.$": "$$.Execution.Id"
              }
            },
            Retry: [{
              "ErrorEquals": ["States.TaskFailed"],
              "IntervalSeconds": 1,
              "MaxAttempts": 2,
              "BackoffRate": 2.0
            }],
            TimeoutSeconds: 300,
            ResultPath: "$.TaskResult",
            OutputPath: "$"
          };
          break;

        case "assigntask":
          template = {
            Type: "Task",
            Resource: "arn:aws:states:::lambda:invoke",
            Parameters: {
              FunctionName:
                `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
              Payload: {
                type: "ASSIGN_TASK",
                siteID: getAttribute(block, 'siteid'),
                workflowID: getAttribute(block, 'workflowid'),
                workflowTrigger: getAttribute(block, 'workflowtrigger'),
                timezone: getAttribute(block, 'timezone'),
                properties: getAttribute(block, 'assign-task-properties'),
                "originalEvent.$": "$",
                "executionID.$": "$$.Execution.Id"
              }
            },
            Retry: [{
              "ErrorEquals": ["States.TaskFailed"],
              "IntervalSeconds": 1,
              "MaxAttempts": 2,
              "BackoffRate": 2.0
            }],
            TimeoutSeconds: 300,
            ResultPath: "$.TaskResult",
            OutputPath: "$"
          };
          break;

        case "wait":
          /*
            If waiting for a duration then use seconds else use timestamp for AWS Step function
          */
          let waitForTime = getAttribute(block, 'waitfortime');
          let waitFor = getAttribute(block, 'waitfor');
          template = {
            Type: "Wait",
            ...(waitForTime && waitForTime === 'true' && { Timestamp: getAttribute(block, 'waitfortimestamp') }),
            ...(waitFor && waitFor === 'true' && { Seconds: parseInt(getAttribute(block, 'totalseconds'),10) }),
            OutputPath: "$"
          };

          break;

        case "sendform":
              let sendFormNewPatientOnly = getAttribute(block, 'sendformnewpatientonly') === "true" ? true : false;
              let sendFormViaEmail = getAttribute(block, 'sendformnewpatientemail') === "true" ? true : false;
              let sendFormViaText = getAttribute(block, 'sendformnewpatienttext') === "true" ? true : false;

              template = {
                Type: "Task",
                Resource: "arn:aws:states:::lambda:invoke",
                Parameters: {
                  FunctionName:
                    `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
                  Payload: {
                    type: "SEND_FORM",
                    siteID: getAttribute(block, 'siteid'),
                    workflowID: getAttribute(block, 'workflowid'),
                    workflowTrigger: getAttribute(block, 'workflowtrigger'),
                    timezone: getAttribute(block, 'timezone'),
                    properties: getAttribute(block, 'send-form-properties'),
                    sendFormNewPatientOnly: sendFormNewPatientOnly,
                    sendFormViaEmail: sendFormViaEmail,
                    sendFormViaText: sendFormViaText,
                    ...(sendFormNewPatientOnly && sendFormViaEmail && { sendFormNewPatientEmailTemplateID: getAttribute(block, 'sendformnewpatientemailtemplateid') }),
                    ...(sendFormNewPatientOnly && sendFormViaEmail && { sendFormNewPatientEmailSendWhen: getAttribute(block, 'sendformnewpatientemailsendwhen') }),
                    ...(sendFormNewPatientOnly && sendFormViaText && { sendFormNewPatientSmsTemplateID: getAttribute(block, 'sendformnewpatientsmstemplateid') }),
                    ...(sendFormNewPatientOnly && sendFormViaText && { sendFormNewPatientSmsSendWhen: getAttribute(block, 'sendformnewpatientsmssendwhen') }),
                    "originalEvent.$": "$",
                    "executionID.$": "$$.Execution.Id"
                  }
                },
                Retry: [{
                  "ErrorEquals": ["States.TaskFailed"],
                  "IntervalSeconds": 1,
                  "MaxAttempts": 2,
                  "BackoffRate": 2.0
                }],
                TimeoutSeconds: 300,
                ResultPath: "$.TaskResult",
                OutputPath: "$"
              };

              break;

        case "kanban":
          template = {
            Type: "Task",
            Resource: "arn:aws:states:::lambda:invoke",
            Parameters: {
              FunctionName:
                `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
              Payload: {
                type: "KANBAN",
                siteID: getAttribute(block, 'siteid'),
                workflowID: getAttribute(block, 'workflowid'),
                workflowTrigger: getAttribute(block, 'workflowtrigger'),
                timezone: getAttribute(block, 'timezone'),
                properties: getAttribute(block, 'kanban-properties'),
                "originalEvent.$": "$",
                "executionID.$": "$$.Execution.Id"
              }
            },
            Retry: [{
              "ErrorEquals": ["States.TaskFailed"],
              "IntervalSeconds": 1,
              "MaxAttempts": 2,
              "BackoffRate": 2.0
            }],
            TimeoutSeconds: 300,
            ResultPath: "$.TaskResult",
            OutputPath: "$"
          };
          break;

        case "slack":
          template = {
            Type: "Task",
            Resource: "arn:aws:states:::lambda:invoke",
            Parameters: {
              FunctionName:
                `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
              Payload: {
                type: "SLACK",
                siteID: getAttribute(block, 'siteid'),
                workflowID: getAttribute(block, 'workflowid'),
                workflowTrigger: getAttribute(block, 'workflowtrigger'),
                timezone: getAttribute(block, 'timezone'),
                slackChannelId: getAttribute(block, 'slackchannelid'),
                slackChannelName: getAttribute(block, 'slackchannelname'),
                slackMessage: getAttribute(block, 'slackmessage'),
                "originalEvent.$": "$",
                "executionID.$": "$$.Execution.Id"
              }
            },
            Retry: [{
              "ErrorEquals": ["States.TaskFailed"],
              "IntervalSeconds": 1,
              "MaxAttempts": 2,
              "BackoffRate": 2.0
            }],
            TimeoutSeconds: 300,
            ResultPath: "$.TaskResult",
            OutputPath: "$"
          };
          break;

        default:  // maybe it's either fail or timeout type of block
                  let temp = block.data.filter(a=>a.value === 'Fail');
                  if(temp.length > 0) {
                    // found fail
                    template = {
                      Type: "Task",
                      Resource: "arn:aws:states:::lambda:invoke",
                      Parameters: {
                        FunctionName:
                          `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
                        Payload: {
                          type: "FAIL_TASK",
                          siteID: getAttribute(block, 'siteid'),
                        }
                      },
                      TimeoutSeconds: 300,
                    };
                  }

                  temp = block.data.filter(a=>a.value === 'Timeout');
                  if(temp.length > 0) {
                    // found timeout
                    template = {
                      Type: "Task",
                      Resource: "arn:aws:states:::lambda:invoke",
                      Parameters: {
                        FunctionName:
                          `arn:aws:lambda:us-east-1:581565885944:function:${siteStage}-workflow-service-send-msg-to-misc-msgs-queue`,
                        Payload: {
                          type: "TIMEOUT_TASK",
                          siteID: getAttribute(block, 'siteid'),
                        }
                      },
                      TimeoutSeconds: 300,
                    };
                  }
                  break;
      }
    } catch(err) {      
      throw err;
    }

    return template;
  }

  function getBlockIndex(blocks, block) {
      return blocks.findIndex((b) => b.id === block.id);
  }

  function getChildren(blocks, blockId) {
    return blocks.filter((b) => b.parent === blockId);
  }

  return {
    convert: function (blocks) {
      this.blocks = blocks;

      //console.log(JSON.stringify(stl));
      let currentBlock;
      let state;
      let stateName;
      let currentParent;
      let continueLoop = true;
      let currentBlockIndex = null;

      currentBlock = blocks[0];
      currentBlockIndex = getBlockIndex(blocks, currentBlock);

      let children = getChildren(blocks, currentBlockIndex);

      if (children.length > 0) {
        stateName = currentBlock.id;
        if (children.length > 1) {
          //console.log(`making parallel state`);
          state = makeParallelState(children, blocks);
          //console.log(`Got parallel state back: ${JSON.stringify(state)}`);
          stlTemplate.States.Try.Branches[0].States[currentBlockIndex+1] = state;          
        } else {
          currentParent = children[0];
          currentBlockIndex = getBlockIndex(blocks, currentParent);
          do {
            children = getChildren(blocks, currentBlockIndex);
            /*
            console.log(`current parent`, currentParent);            
            console.log(`children`, children);
            console.log('current block index', currentBlockIndex);
            console.log('stltemplate', stlTemplate);
            */
            
            if (children.length === 0) {
              state = makeState(currentParent);
              console.log('state', state);
              stlTemplate.States.Try.Branches[0].States[currentBlockIndex] = state;
              stlTemplate.States.Try.Branches[0].States[currentBlockIndex].End = true;
              continueLoop = false;
            } else if (children.length > 1) {
              state = makeState(currentParent);
              stlTemplate.States.Try.Branches[0].States[currentBlockIndex] = state;
              //stlTemplate.States.Try.Branches[0].States[currentParent.id].Next = children[0].id;
              stateName = makeParallelStateName(children);
              state = makeParallelState(children, blocks);
              stlTemplate.States.Try.Branches[0].States[stateName] = state;
              stlTemplate.States.Try.Branches[0].States[
                currentBlockIndex
              ].Next = stateName;
              continueLoop = false;
            } else if (children.length === 1) {
              state = makeState(currentParent);
              stlTemplate.States.Try.Branches[0].States[currentBlockIndex] = state;
              stlTemplate.States.Try.Branches[0].States[currentBlockIndex].Next = (currentBlockIndex + 1).toString();
            }
            currentParent = children[0];
            if(currentParent) {
              currentBlockIndex = getBlockIndex(blocks, currentParent);
              if (children[0]) children = getChildren(blocks, currentBlockIndex);
            }
          } while (continueLoop);
        }
      }

      //console.log(stlTemplate);
      //console.log(`${JSON.stringify(stlTemplate)}`);
      return stlTemplate;
    }
  }

})();

export default AwsStlConverter;
